<template>
    <el-dialog :visible.sync="visible" title="任务详情" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" ref="dataForm"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="任务大类" prop="taskType">
                <ren-select v-model="dataForm.taskType" dict-type="taskType" placeholder="任务大类" readonly="true"></ren-select>
            </el-form-item>
            <el-form-item label="任务简述" prop="taskDesc">
                <el-input v-model="dataForm.taskDesc" placeholder="任务简述" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="结算价格及结算方式" prop="taskRequire">
                <el-input type="textarea" v-model="dataForm.taskRequire" placeholder="结算价格及结算方式" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="需求人数" prop="requirePerson">
                <el-input v-model="dataForm.requirePerson" placeholder="需求人数" style="width: 200px" disabled="disabled"></el-input>
                <b class="unitStyle">
                    <el-form-item prop="priceUnit" style="display:inline-block !important">
                        人
                    </el-form-item>
                </b>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="预算" prop="budget">
                        <el-input v-model="dataForm.budget" placeholder="预算" style="width: 200px" disabled="disabled"></el-input>
                        <b class="unitStyle">
                            <el-form-item prop="priceUnit" style="display:inline-block !important">
                                元
                            </el-form-item>
                        </b>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="合同编号" prop="contractCode">
                        <el-input v-model="dataForm.contractCode" placeholder="合同编号" disabled="disabled"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开始日期" prop="startDate">
                        <el-input v-model="dataForm.startDate" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled="disabled"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="结束日期" prop="endDate">
                        <el-input v-model="dataForm.endDate" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled="disabled"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item prop="optionCheck">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                    <el-checkbox-group v-model="optionCheck">
                        <el-checkbox style="margin:0 0 20px 0" name="optionCheck">我已阅读并同意众联平台<span @onclick="readContent">《服务协议》《隐私保护政策》</span></el-checkbox>
                    </el-checkbox-group>
                </el-form>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">接受任务</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      rules: {
        optionCheck: [
          { type: 'array', required: true, message: '请勾选我已详细阅读并同意', trigger: 'change' }
        ]
      },
      visible: false,
      readonly: true,
      optionCheck: '', // 同意协议按钮
      ruleForm: {
        optionCheck: []
      },
      dataForm: {
        id: '',
        taskDesc: '',
        taskRequire: '',
        requirePerson: '',
        budget: '',
        contractCode: '',
        startDate: '',
        endDate: '',
        status: ''
      }
    }
  },
  computed: {},
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/task/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    readContent () {
      alert(888)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let submitForm = {}
        submitForm.taskId = this.dataForm.id
        this.$http.post('/sys/plat/task/accept', submitForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: '接受任务成功',
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
